<template>
    <div class="UserAgreement">
        <div class="u-p-20">
            <!-- 导航栏 -->
            <topHead>
                <img slot="head" src="../../../assets/images/fh.png" alt="" @click="backBefor()" />
                <h3 slot="header">用户服务协议</h3>
            </topHead>
            <div class="con">
                <div>生效时间：2024年6月1日</div>
                <div><br></div>
                <div>
                    &ensp;&ensp;&ensp;&ensp;北京北纬通信科技股份有限公司推出的短信免打扰服务业务是保护用户免受商业营销类短信骚扰的一种防护业务，为使用短信免打扰业务服务，您应当阅读并遵守《用户服务协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容。如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人（以下简称“监护人”）的陪同下阅读和判断是否同意本协议。如果您是中国大陆地区以外的用户，您订立或履行本协议还需要同时遵守您所属和/或所处国家或地区的法律。
                </div>
                <div><br></div>
                <div>一、协议的范围</div>
                <div><br></div>
                <div>1.本协议是您与北纬蜂巢之间关于用户使用北纬蜂巢平台服务所订立的协议。“北纬蜂巢”是指北纬蜂巢中的短信免打扰服务业务。“用户”是指使用北纬蜂巢相关服务的使用人，在本协议中更多地称为“您”。
                </div>
                <div><br></div>
                <div>
                    2.本协议项下的北纬蜂巢服务是指用户可以在北纬蜂巢平台（以下简称“本平台”）中登记不想接收的商业营销类短信，平台将收集登记的用户数据，减少登记用户接收该类短信频率。
                </div>
                <div><br></div>
                <div>3.请您仔细阅读本协议，当您点击“同意”按钮后，本协议即构成对双方有约束力的法律文件。</div>
                <div><br></div>
                <div>4.请您注意：一旦开通短信免打扰服务，服务功能可能会使您无法接收一些有骚扰风险的端口类短信。</div>
                <div><br></div>
                <div>二、隐私声明</div>
                <div><br></div>
                <div>1.适用范围</div>
                <div><br></div>
                <div>(1)您注册北纬蜂巢时，根据平台要求提供的个人信息及电话信息。</div>
                <div><br></div>
                <div>(2)在您使用北纬蜂巢服务、访问平台时，平台自动接收并记录的您浏览器上的服务器数据，包括但不限于IP地址、网站或Cookie中的资料及您要求取用的记录。</div>
                <div><br></div>
                <div>(3)北纬蜂巢通过合法途径取得的用户个人资料。</div>
                <div><br></div>
                <div>(4)北纬蜂巢不会对用户登记行为收取任何费用。</div>
                <div><br></div>
                <div>2.信息使用</div>
                <div><br></div>
                <div>(1)北纬蜂巢不会向任何人出售或出借您的个人信息，除非事先得到您的许可。</div>
                <div><br></div>
                <div>(2)为服务用户的目的，北纬蜂巢可能通过使用您的个人信息，向您提供服务。</div>
                <div><br></div>
                <div>(3)北纬蜂巢承诺：非经法律程序不会泄露您的个人信息（如姓名、肖像、身份证号、电话、住址等）。</div>
                <div><br></div>
                <div>3.信息披露</div>
                <div><br></div>
                <div>您的个人信息将在下述情况下部分或全部被披露：</div>
                <div><br></div>
                <div>(1)经您同意，向第三方披露。</div>
                <div><br></div>
                <div>(2)如您是符合资格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。</div>
                <div><br></div>
                <div>(3)根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露。</div>
                <div><br></div>
                <div>(4)如果您出现违反中国有关法律或者平台规则的情况，需要向第三方披露。</div>
                <div><br></div>
                <div>(5)为提供您所要求的产品和服务，而必须和第三方分享您的个人信息。</div>
                <div><br></div>
                <div>(6)其他本平台根据法律或者平台规则认为合适的披露。</div>
                <div><br></div>
                <div>4.信息授权</div>
                <div><br></div>
                <div>
                    (1)本人授权北纬蜂巢，除法律另有规定之外，将本人提供给北纬蜂巢的信息、享受北纬蜂巢服务产生的信息（包括本用户协议签署之前提供和产生的信息）以及北纬蜂巢根据本条约定查询、收集的信息，用于北纬蜂巢及其因服务必要委托的合作伙伴为本人提供服务、开展市场调查与信息数据分析。
                </div>
                <div><br></div>
                <div>(2)本人授权北纬蜂巢，除法律另有规定之外，基于为本人提供更优质服务的目的，向北纬蜂巢因服务必要开展合作的伙伴提供、查询、收集本人的信息。</div>
                <div><br></div>
                <div>(3)为确保本人信息的安全，北纬蜂巢及其合作伙伴对上述信息负有保密义务，并采取各种措施保证信息安全。</div>
                <div><br></div>
                <div>(4)本条自本协议签署时生效，具有独立法律效力，不受协议成立与否及效力状态变化的影响。</div>
                <div><br></div>
                <div>(5)如您不同意上述授权条款的部分或全部，可联系北纬蜂巢服务电话4001994001取消或变更授权。</div>
                <div><br></div>
                <div>5.您须做到</div>
                <div><br></div>
                <div>(1)用户名和昵称的注册与使用应符合网络道德，遵守中华人民共和国的相关法律法规。</div>
                <div><br></div>
                <div>(2)用户名和昵称中不能含有威胁、淫秽、漫骂、非法、侵害他人权益等有争议性的文字。</div>
                <div><br></div>
                <div>(3)注册成功后，您必须保护好自己的帐号和密码，因会员本人泄露而造成的任何损失由您本人负责。</div>
                <div><br></div>
                <div>(4)不得盗用他人帐号，由此行为造成的后果自负。</div>
                <div><br></div>
                <div><br></div>
                <div>三、服务条款的确认和接纳</div>
                <div><br></div>
                <div>
                    1.各项服务的所有权和运作权归北纬蜂巢所有。用户同意所有注册协议条款并完成注册程序，才能成为北纬蜂巢的正式用户。用户确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。
                </div>
                <div><br></div>
                <div>2.用户点击同意本协议的，即视为用户确认自己具有享受北纬蜂巢服务等相应的权利能力和行为能力，能够独立承担法律责任。</div>
                <div><br></div>
                <div>3.如果您在18周岁以下，您只能在父母或监护人的监护参与下才能使用本平台服务。</div>
                <div><br></div>
                <div>4.北纬蜂巢保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容的权利。</div>
                <div><br></div>
                <div>四、北纬蜂巢网络服务</div>
                <div><br></div>
                <div>
                    &ensp;&ensp;&ensp;&ensp;北纬蜂巢的网络服务是按照现有技术和条件所能达到的现状提供的。北纬蜂巢会尽最大努力为用户提供服务，确保服务的连贯性和安全性；但北纬蜂巢不能随时预见和防范法律、
                    技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。</div>
                <div><br></div>
                <div>五、用户依法言行义务</div>
                <div><br></div>
                <div>本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：</div>
                <div><br></div>
                <div>1.不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论。
                </div>
                <div><br></div>
                <div>2.不得利用北纬蜂巢从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动。</div>
                <div><br></div>
                <div>3.不得干扰北纬蜂巢的正常运转，不得侵入北纬蜂巢及国家计算机信息系统。</div>
                <div><br></div>
                <div>4.不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽的、不文明的等信息资料。</div>
                <div><br></div>
                <div>5.不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论。</div>
                <div><br></div>
                <div>6.不得教唆他人从事本条所禁止的行为。</div>
                <div><br></div>
                <div>7.不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容。</div>
                <div><br></div>
                <div>
                    用户应关注并遵守北纬蜂巢不时公布或修改的各类合法规则规定。北纬蜂巢保有删除各类不符合法律政策或不真实的信息内容而无须通知用户的权利。若用户未遵守以上规定的，北纬蜂巢有权作出独立判断并采取暂停或关闭用户帐号等措施。用户须对自己在网上的言论和行为承担法律责任。
                </div>
                <div><br></div>
                <div>六、所有权及知识产权条款</div>
                <div><br></div>
                <div>
                    1.用户一旦接受本协议，即表明该用户主动将其在任何时间段在北纬蜂巢发表的任何形式的信息内容的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给北纬蜂巢所有，用户同意北纬蜂巢有权就任何主体侵权而单独提起诉讼。
                </div>
                <div><br></div>
                <div>
                    2.本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2011年版著作权法确定）及相关法律规定的著作财产权等权利转让书面协议，其效力及于用户在北纬蜂巢上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。
                </div>
                <div><br></div>
                <div>3.用户同意并已充分了解本协议的条款，承诺不将已发表于北纬蜂巢的信息，以任何形式发布或授权其它主体以任何方式使用（包括但限于在各类网站、媒体上使用）。</div>
                <div><br></div>
                <div>
                    4.除法律另有强制性规定外，未经北纬蜂巢明确的特别书面许可，任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用北纬蜂巢的信息内容，否则，北纬蜂巢有权追究其法律责任。
                </div>
                <div><br></div>
                <div>
                    5.北纬蜂巢所刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是北纬蜂巢或其内容提供者的财产，受中国和国际版权法的保护。北纬蜂巢上所有内容的汇编是北纬蜂巢的排他财产，受中国和国际版权法的保护。北纬蜂巢上所有软件都是北纬蜂巢或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。
                </div>
                <div><br></div>
                <div>七、责任限制及不承诺担保</div>
                <div><br></div>
                <div>
                    1.除非另有明确的书面说明，北纬蜂巢及其所包含的或以其它方式通过北纬蜂巢提供给您的全部信息、内容、材料、产品（包括软件）和服务，均是在“按现状”和“按现有”的基础上提供的。除非另有明确的书面说明，北纬蜂巢不对平台运营及平台上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。
                </div>
                <div><br></div>
                <div>
                    2.北纬蜂巢不担保通过本平台提供给您的全部信息、内容、材料、产品（包括软件）和服务、及服务器或北纬蜂巢发出的电子信件、信息没有病毒或其他有害成分。如因不可抗力或其它本站无法控制的原因使北纬蜂巢系统崩溃或无法正常使用导致网上程序（如注册流程）无法完成或丢失有关的信息、记录等，北纬蜂巢会合理地尽力协助处理善后事宜。
                </div>
                <div><br></div>
                <div>3.北纬蜂巢保留对本协议作出不定时修改的权利。</div>
                <div><br></div>
                <div>4.用户对处理结果不满意，可以向北纬蜂巢提出投诉，北纬蜂巢有义务依据情况予以解决。</div>
                <div><br></div>
                <div>5.系统因下列状况无法正常运作，使用户无法使用服务时，北纬蜂巢不承担损害赔偿责任，该状况包括但不限于：</div>
                <div><br></div>
                <div>（1）北纬蜂巢在本平台公告之系统停机维护期间；</div>
                <div><br></div>
                <div>（2）电信设备出现故障不能进行数据传输的；</div>
                <div><br></div>
                <div>（3）因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成系统障碍不能执行业务的；</div>
                <div><br></div>
                <div>（4）由于黑客攻击、电信部门技术调整或故障、银行方面的问题等原因而造成的服务中断或者延迟。</div>
                <div><br></div>
                <div>八、协议更新及用户关注义务</div>
                <div><br></div>
                <div>
                    &ensp;&ensp;&ensp;&ensp;根据国家法律法规变化及网络运营需要，北纬蜂巢有权对本协议条款不时地进行修改，修改后的协议一旦被使用在北纬蜂巢上即表示生效，并代替原来的协议。用户可随时登陆查阅最新协议；用户有义务不时关注并阅读最新版的协议及北纬蜂巢公告。如用户不同意更新后的协议，可以且应立即停止接受北纬蜂巢依据本协议提供的服务；如用户继续使用北纬蜂巢提供的服务，即视为同意更新后的协议。北纬蜂巢建议您在使用服务之前阅读本协议及相关公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。
                </div>
                <div><br></div>
                <div>九、法律管辖和适用</div>
                <div><br></div>
                <div>
                    &ensp;&ensp;&ensp;&ensp;本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向北京市海淀区人民法院提起诉讼。
                </div>
                <div><br></div>
                <div>十、其它</div>
                <div><br></div>
                <div>1.
                    北纬蜂巢尊重用户和消费者的合法权利，本协议及北纬蜂巢上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为用户和消费者提供服务。北纬蜂巢欢迎用户和社会各界提出意见和建议，我们将虚心接受并适时修改本协议及各类规则。
                </div>
                <div><br></div>
                <div>2. 您注册协议并点击“同意”按钮后，使用北纬蜂巢即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。</div>
            </div>
        </div>
    </div>
</template>

<script>
import topHead from "../../../components/topHead.vue"
export default {
    components: { topHead },
    data() {
        return {}
    },

    created() { },
    // 组件方法
    methods: {
        backBefor() {
            this.$router.push("/WillRegister")
        }
    },

    computed: {},

    watch: {},

    mounted() { },
}
</script>

<style scoped lang='scss'>
.UserAgreement {
    font-size: px2rem(26);

    .con {
        padding: px2rem(20);
        line-height: px2rem(38);
    }

    .topHead {
        position: sticky;
        /* 新属性sticky */
        top: 0;
        background: #fff;
    }
}
</style>